import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { NetworkError } from "./errors.js";
import { handleApiFailure } from "./failure-handler.js";

/**
 * The one place both cache-level error handlers are wired (TASK.md: "never per-retry, never
 * per-component"). `navigateToSignIn` is injected so this module (and failure-handler.ts under
 * it) never imports the router directly — main.tsx supplies `() => router.navigate({ to:
 * "/sign-in" })` once, at boot.
 */
export function createQueryClient(navigateToSignIn: () => void): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        handleApiFailure(error, query.meta, navigateToSignIn);
      },
    }),
    mutationCache: new MutationCache({
      onError: (error, _variables, _onMutateResult, mutation) => {
        handleApiFailure(error, mutation.meta, navigateToSignIn);
      },
    }),
    defaultOptions: {
      queries: {
        // "Queries retry at most once, network errors only" (TASK.md).
        retry: (failureCount, error) => failureCount < 1 && error instanceof NetworkError,
      },
    },
  });
}
